<wiz-hgroup width="100%" height="100%" class="section-container-parent" padding="5px">
  
  <div #scr width="100%" [innerHTML]="message" style="font-size: 10;overflow-y: auto !important;">
    <!-- <div width="100%" [innerHTML]="message" style="font-size: 10;"></div> -->
  </div>
  <!-- <wiz-vgroup width="100%" height="100%" class="section-container">
    <wiz-hgroup width="100%">
      <wiz-label [wizLabel]="'$.common.loading.$'" class="smallTitleLabel" width="100%"></wiz-label>
      <wiz-icon class="image-purple" (click)="doCancel()">close</wiz-icon>
    </wiz-hgroup>
    
    
  </wiz-vgroup> -->
  <!-- fin zone détail -->
</wiz-hgroup>
